import { ApiBase } from '@/api/methods/ApiBase'

export namespace ActivateTokensApi {
  /**
   * トークン確認API(成功時レスポンスコード200、失敗時404)
   *
   * @param activateToken トークン情報
   */
  export async function checkToken(activateToken: string): Promise<void> {
    const params = {
      activateToken: activateToken,
    }
    await ApiBase.get('/activate/tokens', params)
  }
}
